import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PoStatusUpdateService } from '../../Services/job-allocation-to-vendors/po-status-update.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from 'src/app/Services/pager.service';
import { PoStatusUpdateDetails, PoStatusUpdateFilters, UpdatedPODetails, poApprovalDetail } from 'src/app/Models/job-allocation-to-vendors/po-status-update';
import { VendorFinalizationService } from 'src/app/Services/job-allocation-to-vendors/vendor-finalization.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { formatDate } from '@angular/common';
import { ToastrModule, ToastrService } from 'ngx-toastr';


export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MMM-yyyy', this.locale);;
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-po-status-update',
  templateUrl: './po-status-update.component.html',
  styleUrls: ['./po-status-update.component.css'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    DatePipe
  ]
})

export class PoStatusUpdateComponent implements OnInit {
  @ViewChild('year') year;
  userID: string;
  roleID: string;
  selectedJobNumber: any;
  selectedRMHName: any;
  selectedJobType: any;
  selectedBrand: any;
  selectedCrop: any;
  selectedLanguage: any;
  selectedStatus: any;
  selectedMonth: any;
  isSelect: any = "0";
  poStatusFilters: PoStatusUpdateFilters = new PoStatusUpdateFilters();
  poStatusDetails: PoStatusUpdateDetails[] = [];
  mainPoDetails: PoStatusUpdateDetails[] = [];
  vendorTypeDetail: any[] = [];
  loader: string = 'none';
  files: File[] = [];
  fileName: string = '';
  pageSetting: number = 10;
  pager: any = {};
  //model: any[];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  selectedState: any;
  userName: string;
  Date = new Date();
  bgColor: string = 'LightYellow'
  selectedStatusCustom: number;
  sortDirection: string = '';
  ascNumberSort: boolean = true;
  @ViewChild('file') input;
  displayPoAssignment: string = 'none';
  poApprovalDetail: poApprovalDetail;
  poGridDetail: poApprovalDetail[] = [];
  poApprovedQuantity: number;
  poRemainingQuantity: number;
  remainingPoQty: number;
  popJobNumber: string;
  popFAQ: number;
  popPoIssueQty: number;
  popPoNumber: string;
  popIssueDate: any;
  popVendor: any;
  popPoIssueDate: any;
  displayUpdate: number = 0;
  poDetailsID: number = 0;
  POIssueDate: Date;
  callbackChange: string = 'none';
  tomorrow: Date;
  popEstDelDate: Date;

  PoNumberValidation: boolean=false;
  poNumberUpdate:any;
//Region Remarks for partial Cancellation
  displayPanel:string='none';
  fadeBackground:string='none';
  RejectedQty:number=0;
  RemarksText:string='';
  gridIndex:number=0;
  editAction:string;
  isCancelationApprove:boolean=true;
  //End Remarks

  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobNumberID',
    textField: 'jobNumberName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings2: IDropdownSettings = {
    singleSelection: false,
    idField: 'rMHCode',
    textField: 'rMHName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobTypeID',
    textField: 'jobTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: false,
    idField: 'cropID',
    textField: 'cropName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: 'brandID',
    textField: 'brandName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: 'languageID',
    textField: 'languageName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings7: IDropdownSettings = {
    singleSelection: false,
    idField: 'stateID',
    textField: 'stateName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings8: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings9: IDropdownSettings = {
    singleSelection: false,
    idField: 'requirementStatusID',
    textField: 'requirementStatusName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  yearSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'year',
    textField: 'year',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: false,
    limitSelection: -1,
    clearSearchFilter: false,
    itemsShowLimit: 1,
    searchPlaceholderText: 'Search',
    noDataAvailablePlaceholderText: 'No Year Found',
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  constructor(private poStatusUpdateService: PoStatusUpdateService, private snackBar: MatSnackBarComponent, private router: Router,
    private _pagerService: PagerService, private datepipe: DatePipe, private vendorFinalizationService: VendorFinalizationService,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.userName = localStorage.getItem('mcmt_userName');
    this.selectedStatusCustom = 0;
    this.displayPoAssignment = 'none';
    this.tomorrow = new Date(new Date().setDate(new Date().getDate() + 30));
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.poStatusUpdateFilters();
    this.vendorTypes();
    this.displayUpdate = 0;
    this.callbackChange = 'none';
  }

  poStatusUpdateFilters() {
    this.loader = 'block';
    this.poStatusUpdateService.poStatusUpdateFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.poStatusFilters = resData.data;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.poStatusFilters.currentRequirementYear[0].currentrequirementYear,
            text: this.poStatusFilters.currentRequirementYear[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.poStatusUpdateDetails();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != this.poStatusFilters.currentRequirementYear[0].currentrequirementYear)
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }

  poStatusUpdateDetails() {
    this.loader = 'block';
    this.selectedJobNumber = undefined;
    this.selectedRMHName = undefined;
    this.selectedJobType = undefined;
    this.selectedBrand = undefined;
    this.selectedCrop = undefined;
    this.selectedLanguage = undefined;
    this.selectedStatus = undefined;
    this.selectedMonth = undefined;
    this.selectedState = undefined;
    let selectedYear = ''
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.text; }).join(",");
    this.poStatusUpdateService.getPoStatusUpdate(this.selectedJobNumber, this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop,
      this.selectedLanguage, this.selectedStatus, this.selectedMonth, this.selectedState,selectedYear)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.poStatusDetails = resdata.data;
          //this.model = resdata.data;
          this.mainPoDetails = resdata.data;
          this.filter();
          //this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          //  this.toastr.error(resdata.msg, 'Close', 'red-snackbar');
          this.toastr.error("Status updated successfully");
          this.loader = 'none';
        }
      })
  }

  updatePO(index: any): void {
    // if (this.poStatusDetails[index].quantity != 0 && this.poStatusDetails[index].poIssuedDate != '1900-01-01 00:00:00.000'
    //   //if (this.poStatusDetails[index].poIssuedDate != '1900-01-01 00:00:00.000'
    //   && this.poStatusDetails[index].poNumber != 0) {
    // if (this.poStatusDetails[index].quantity == this.poStatusDetails[index].finalQuantity) {
    if (this.poStatusDetails[index].vendorType == "1") {
      let updatedPO: UpdatedPODetails[] = [];
      let issueDate: Date;
      let approvedQty: string;
      if (this.poStatusDetails[index].poIssuedDate.toString().includes('GMT')) {
        issueDate = this.poStatusDetails[index].poIssuedDate.toString().replace('GMT+0530 (India Standard Time)', '').slice(4);
      }
      else {
        issueDate = this.poStatusDetails[index].poIssuedDate;
      }
      if (this.poStatusDetails[index].quantity.toString().includes(',')) {
        approvedQty = this.poStatusDetails[index].quantity.replace(',', '');
      }
      else {
        approvedQty = this.poStatusDetails[index].quantity;
      }
      var updatedDetails = {
        RequirementID: this.poStatusDetails[index].jobNumber,
        Quantity: approvedQty,
        PONumber: this.poStatusDetails[index].poNumber,
        POIssuedDate: issueDate,
        RequirementType: this.poStatusDetails[index].requirementType,
      };
      updatedPO.push(updatedDetails);
      this.loader = 'block';
      this.poStatusUpdateService.updatePO(updatedPO)
        .subscribe((resdata: any) => {
          if (resdata.status == true) {
            if (resdata.data[0].status == 'true') {
              this.toastr.success(resdata.data[0].msg);
              this.poStatusUpdateDetails();
              this.filter();
              this.loader = 'none';
            }
            else {
              this.toastr.error(resdata.data[0].msg);
              this.loader = 'none';
              this.poStatusUpdateDetails();
              this.filter();
            }
          }
          else {
            this.isSelect = "0";
            this.toastr.error(resdata.data[0].msg);
            this.poStatusUpdateDetails();
            this.loader = 'none';
          }
        })
    }
    else {
      this.isSelect = "0";
    }
    // }
    // else {
    //   this.isSelect = "0";
    //   if(this.poStatusDetails[index].quantity > this.poStatusDetails[index].finalQuantity){
    //     this.toastr.error("PO Quantity can not be more than Final Quantity", 'Close', 'red-snackbar');
    //   }
    //   else{
    //     this.toastr.error("PO Quantity can not be less than Final Quantity", 'Close', 'red-snackbar');
    //   }
    //   this.poStatusUpdateDetails();
    //   this.loader = 'none';
    // }
    // }
    // else {
    //   this.isSelect = "0";
    //   this.toastr.error("Fill all parameters", 'Close', 'red-snackbar');
    //   this.poStatusUpdateDetails();
    //   this.loader = 'none';
    // }
  }

  excelDownload() {
    this.loader = 'block';
    let selectJobNo: any[] = this.selectedJobNumber;
    let selectRmh: any[] = this.selectedRMHName;
    let selectJob: any[] = this.selectedJobType;
    let selectBrand: any[] = this.selectedBrand;
    let selectCrop: any[] = this.selectedCrop;
    let selectLanguage: any[] = this.selectedLanguage;
    let selectStatus: any[] = this.selectedStatus;
    let selectMonth: any[] = this.selectedMonth;
    let selectState: any[] = this.selectedState;
    let customJobNo: string = "";
    let customRmh: string = "";
    let customJob: string = "";
    let customBrand: string = "";
    let customCrop: string = "";
    let customLanguage: string = "";
    let customStatus: string = "";
    let customMonth: string = "";
    let customState: string = "";
    let selectedYear = ''
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.text; }).join(",");
    if (selectJobNo != undefined) {
      selectJobNo.forEach(x => {
        if (x.length == 0) {
          customJobNo = "";
        }
        else {
          if (customJobNo == "") {
            customJobNo = x.jobNumberName;
          }
          else {
            customJobNo = customJobNo.concat(",");
            customJobNo = customJobNo.concat(x.jobNumberName);
          }
        }
      })
    }
    if (selectRmh != undefined) {
      selectRmh.forEach(x => {
        if (x.length == 0) {
          customRmh = "";
        }
        else {
          if (customRmh == "") {
            customRmh = x.rMHCode;
          }
          else {
            customRmh = customRmh.concat(",");
            customRmh = customRmh.concat(x.rMHCode);
          }
        }
      })
    }
    if (selectJob != undefined) {
      selectJob.forEach(x => {
        if (x.length == 0) {
          customJob = "";
        }
        else {
          if (customJob == "") {
            customJob = x.jobTypeName;
          }
          else {
            customJob = customJob.concat(",");
            customJob = customJob.concat(x.jobTypeName);
          }
        }
      })
    }
    if (selectBrand != undefined) {
      selectBrand.forEach(x => {
        if (x.length == 0) {
          customBrand = "";
        }
        else {
          if (customBrand == "") {
            customBrand = x.brandName;
          }
          else {
            customBrand = customBrand.concat(",");
            customBrand = customBrand.concat(x.brandName);
          }
        }
      })
    }
    if (selectCrop != undefined) {
      selectCrop.forEach(x => {
        if (x.length == 0) {
          customCrop = "";
        }
        else {
          if (customCrop == "") {
            customCrop = x.cropName;
          }
          else {
            customCrop = customCrop.concat(",");
            customCrop = customCrop.concat(x.cropName);
          }
        }
      })
    }
    if (selectLanguage != undefined) {
      selectLanguage.forEach(x => {
        if (x.length == 0) {
          customLanguage = "";
        }
        else {
          if (customLanguage == "") {
            customLanguage = x.languageName;
          }
          else {
            customLanguage = customLanguage.concat(",");
            customLanguage = customLanguage.concat(x.languageName);
          }
        }
      })
    }
    if (selectStatus != undefined) {
      selectStatus.forEach(x => {
        if (x.length == 0) {
          customStatus = "";
        }
        else {
          if (customStatus == "") {
            customStatus = x.requirementStatusID.toString();
          }
          else {
            customStatus = customStatus.concat(",");
            customStatus = customStatus.concat(x.requirementStatusID.toString());
          }
        }
      })
    }
    if (selectMonth != undefined) {
      selectMonth.forEach(x => {
        if (x.length == 0) {
          customMonth = "";
        }
        else {
          if (customMonth == "") {
            customMonth = x.item_id;
          }
          else {
            customMonth = customMonth.concat(",");
            customMonth = customMonth.concat(x.item_id);
          }
        }
      })
    }
    if (selectState != undefined) {
      selectState.forEach(x => {
        if (x.length == 0) {
          customState = "";
        }
        else {
          if (customState == "") {
            customState = x.stateName;
          }
          else {
            customState = customState.concat(",");
            customState = customState.concat(x.stateName);
          }
        }
      })
    }
    this.poStatusUpdateService.downloadExcel(customJobNo, customRmh, customJob, customBrand, customCrop,
      customLanguage, customStatus, customMonth, customState,selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let cYear = this.year.selectedItems[0].id;
          let ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_PoStatusUpdate_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
        //  this.toastr.error("No Data Found.");
          this.loader = 'none';
        }
      );
  }

  // Start :For Pagination
  // setPage(page: number, pageSize: number) {
  //   // get pager object from service
  //   if (this.modalSetting == 0) {
  //     this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
  //     this.poStatusDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //   }
  //   else {
  //     if (this.modalSetting == 1) {
  //       this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
  //       this.poStatusDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //     else {
  //       this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
  //       this.poStatusDetails = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //   }
  //   // get current page of items
  // }


  vendorTypes() {
    this.loader = 'block';
    this.vendorFinalizationService.vendorTypes()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorTypeDetail = resData.data.vendorTypes;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  filesAdd(files: File[]) {
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    this.loader = 'block';
    this.poStatusUpdateService.uploadPoStatus(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data == 1) {
            this.toastr.error(resData.message);
            this.loader = 'none';
            this.input.nativeElement.value = null;
          }
          else {
            if (resData.data[0].status == 'true') {
              this.toastr.success(resData.data[0].msg);
              this.loader = 'none';
              this.poStatusUpdateDetails();
              this.filter();
              this.input.nativeElement.value = null;
            } else {
              this.toastr.error(resData.data[0].msg);
              this.loader = 'none';
              this.input.nativeElement.value = null;
            }
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }

  filter() {
    let customRmh: any[] = this.selectedRMHName;
    let customBrand: any[] = this.selectedBrand;
    let customJob: any[] = this.selectedJobType;
    let customCrop: any[] = this.selectedCrop;
    let customLanguage: any[] = this.selectedLanguage;
    let customJobNo: any[] = this.selectedJobNumber;
    let customState: any[] = this.selectedState;
    let customMonth: any[] = this.selectedMonth;
    let customStatus: any[] = this.selectedStatus;
    let selectedYear = ''
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.text; }).join(",");
    
    let filteredItem = [];
    
    let PoStatusDetail: PoStatusUpdateDetails[] = this.mainPoDetails;
    let resultDetail: PoStatusUpdateDetails[] = [];
    let resultId = [];
    let filter: boolean = false;
    let splitString: any[] = [];
    
    resultDetail=PoStatusDetail;
    
    if (customRmh != undefined && customRmh.length > 0) {
      customRmh.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.rmhId == element.rMHCode) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }

    if (customBrand != undefined && customBrand.length > 0) {
      customBrand.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.brand == element.brandName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }
    
    if (customCrop != undefined && customCrop.length > 0) {
      customCrop.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.crop == element.cropName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }
    
    if (customJob != undefined && customJob.length > 0) {
      customJob.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.jobType == element.jobTypeName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }

    if (customLanguage != undefined && customLanguage.length > 0) {
      customLanguage.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.language == element.languageName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }    
    
    if (customJobNo != undefined && customJobNo.length > 0) {
      customJobNo.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.jobNumber == element.jobNumberName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }    
    
    if (selectedYear != undefined && selectedYear!= '') {
      resultDetail.forEach(detail => {
        if (detail.rollingYear == selectedYear) {
          filteredItem.push(detail.jobNumber);
        }
      })
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }

    if (customState != undefined && customState.length > 0) {
      customState.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.state == element.stateName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }
    
    if (customMonth != undefined && customMonth.length > 0) {
      customMonth.forEach(element => {
        resultDetail.forEach(detail => {
          splitString = detail.requirementMonth.split("'");
          if (splitString[0] == element.item_text) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }
    
    if (customStatus != undefined && customStatus.length > 0) {
      customStatus.forEach(element => {
        resultDetail.forEach(detail => {
          if (detail.orderStatus == element.requirementStatusName) {
            filteredItem.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredItem;
      filteredItem=[];
      resultDetail = resultDetail.filter( el => resultId.includes( el.jobNumber ) );
      filter = true;
    }

    this.poStatusDetails = resultDetail;
    this.sortDirection = '';
    //this.setPage(1, this.pageSetting)
  }
  onItemSelect() {

  }
  onSelectAll() {

  }

  onItemSelectJob() {
    let jobNo = this.selectedJobNumber;
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customStatus = [];
    let customLanguage = [];
    let customMonth = [];
    let customState = [];
    let customJobNo = [];
    this.poStatusFilters.jobNumbers.forEach(x => {
      jobNo.forEach(element => {
        if (element.jobNumberName == x.jobNumberName) {
          customJobNo.push(x);
        }
      });
    })
    let active: boolean = true;
    this.poStatusFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    // this.poStatusFilters.orderStatus.forEach(x => {
    //   customJobNo.forEach(element => {
    //     if (x.requirementStatusID == element.statusID) {
    //       if (customStatus.length == 0) {
    //         customStatus.push(x);
    //       }
    //       else {
    //         customStatus.forEach(y => {
    //           if (y.item_id == x.requirementStatusID) {
    //             active = false;
    //           }
    //         })
    //         if (active == true) {
    //           customStatus.push(x);
    //         }
    //         active = true;
    //       }
    //     }
    //   });
    // })
    this.poStatusFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    // this.poStatusFilters.crops.forEach(x => {
    //   customJobNo.forEach(element => {
    //     if (x.cropID == element.cropID) {
    //       if (customCrop.length == 0) {
    //         customCrop.push(x);
    //       }
    //       else {
    //         customCrop.forEach(y => {
    //           if (y.cropID == x.cropID) {
    //             active = false;
    //           }
    //         })
    //         if (active == true) {
    //           customCrop.push(x);
    //         }
    //         active = true;
    //       }
    //     }
    //   });
    // })
    this.poStatusFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    // this.poStatusFilters.languages.forEach(x => {
    //   customJobNo.forEach(element => {
    //     if (x.languageID == element.languageID) {
    //       if (customLanguage.length == 0) {
    //         customLanguage.push(x);
    //       }
    //       else {
    //         customLanguage.forEach(y => {
    //           if (y.languageID == x.languageID) {
    //             active = false;
    //           }
    //         })
    //         if (active == true) {
    //           customLanguage.push(x);
    //         }
    //         active = true
    //       }
    //     }
    //   });
    // })
    this.poStatusFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedStatus = customStatus;
  }

  onItemSelectState() {
    let customState: any[] = this.selectedState;
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let active: boolean = true;
    this.poStatusFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }

  onStateDeSelect() {
    this.onItemSelectState();
  }

  onJobDeSelect() {
    this.onItemSelectJob();
  }

  onItemSelectAllJob() {
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customLanguage = [];
    let customMonth = [];
    let customStatus = [];
    let customState = [];
    let customJobNo = [];
    this.poStatusFilters.jobNumbers.forEach(x => {
      customJobNo.push(x);
    })
    let active: boolean = true;
    this.poStatusFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.poStatusFilters.orderStatus.forEach(x => {
      customJobNo.forEach(element => {
        if (x.requirementStatusID == element.statusID) {
          if (customStatus.length == 0) {
            customStatus.push(x);
          }
          else {
            customStatus.forEach(y => {
              if (y.item_id == x.requirementStatusID) {
                active = false;
              }
            })
            if (active == true) {
              customStatus.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.poStatusFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.poStatusFilters.crops.forEach(x => {
      customJobNo.forEach(element => {
        if (x.cropID == element.cropID) {
          if (customCrop.length == 0) {
            customCrop.push(x);
          }
          else {
            customCrop.forEach(y => {
              if (y.cropID == x.cropID) {
                active = false;
              }
            })
            if (active == true) {
              customCrop.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.poStatusFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    this.poStatusFilters.languages.forEach(x => {
      customJobNo.forEach(element => {
        if (x.languageID == element.languageID) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.languageID == x.languageID) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      });
    })
    this.poStatusFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedStatus = customStatus;
  }
  onJobAllDeSelect() {
    this.selectedJobType = [];
    this.selectedLanguage = [];
    this.selectedMonth = [];
    this.selectedRMHName = [];
    this.selectedState = [];
    this.selectedCrop = [];
    this.selectedBrand = [];
    this.selectedStatus = [];
  }
  onItemSelectAllState() {
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let customState = [];
    this.poStatusFilters.states.forEach(x => {
      customState.push(x);
    })
    let active: boolean = true;
    this.poStatusFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.poStatusFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }
  onStateAllDeSelect() {
    this.selectedRMHName = [];
    this.selectedLanguage = [];
  }

  saveApprovedPoStatus(index: any) {
    let selectedId = this.poStatusDetails[index].jobNumber;
    let selectedPonumber = this.poStatusDetails[index].poNumber;
    let selectedQty = this.poStatusDetails[index].quantity;
    let selectedDate = this.poStatusDetails[index].poIssuedDate;
    this.mainPoDetails.forEach(element => {
      if (element.jobNumber == selectedId) {
        element.poNumber = selectedPonumber;
        element.quantity = selectedQty;
        element.poIssuedDate = selectedDate;
      }
    });
  }


  poNumberUpdated(index: any) {
    if (this.poStatusDetails[index].poNumber != 0) {
      this.poStatusDetails[index].quantity = this.poStatusDetails[index].finalQuantity;
    }
    this.saveApprovedPoStatus(index);
  }

  sort() {
    let sortedArray: PoStatusUpdateDetails[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.poStatusDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.poStatusDetails = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.poStatusDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.poStatusDetails = sortedArray.reverse();
    }
  }
  showEditPanel(detail: any,index:number) {
    this.displayPoAssignment = 'block';
    this.popJobNumber = detail.jobNumber;
    this.popPoIssueQty = Number(detail.finalQuantity);
    this.popFAQ = detail.finalQuantity;
    this.GetPoApprovalDetails(0, detail.jobNumber, 0, 0, '', 0, null, null, 'SELECT');
    this.GetPoApprovalDetails(0, detail.jobNumber, 0, 0, '', 0, null, null, 'GRID');
    this.gridIndex=index;
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('overlay-back');
  }
  closePanel() {
    this.displayPoAssignment = 'none';
    this.popPoIssueQty = null;
    this.popPoNumber = null;
    this.popJobNumber = null;
    this.displayUpdate = 0;
    this.poDetailsID = 0;
    this.callbackChange = 'none';
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('overlay-back');
    this.poStatusUpdateDetails();
  }

  GetPoApprovalDetails(id: number, jobNumber: string, vendorType: number, approvedQuantity: number, poNumber: string, poQuantity: number, poIssueDate: Date, poEstimateDeliveryDate: Date, action: string,cancellationRemark:string=null) {
    this.loader = 'block';
    let poIssuedDate = this.datepipe.transform(poIssueDate, 'dd-MMM-yyyy');
    let poEstimatedDeliveryDate = this.datepipe.transform(poEstimateDeliveryDate, 'dd-MMM-yyyy');
    this.poStatusUpdateService.poApprovalDetails(id, jobNumber, vendorType, approvedQuantity, poNumber, poQuantity, poIssuedDate, poEstimatedDeliveryDate, action,cancellationRemark)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.poApprovalDetail = resdata.data;
          if (action == 'SUBMIT') {
            if (resdata.data[0].column1 == "true") {
              this.toastr.success("PO Details Submitted Successfully");
            }
            else
              this.toastr.error("Can not Submit record,Please add as list before submit / All Approved Quantity is not assigned");
          }

          else if (action == 'SELECT') {
            if (this.callbackChange == 'call') {
              this.poRemainingQuantity = this.poApprovalDetail[0].remainingQuantity;
              this.isCancelationApprove=this.poApprovalDetail[0].cancellationApproval;
            }
            else {
              this.poRemainingQuantity = this.poApprovalDetail[0].remainingQuantity;
              this.poApprovedQuantity = this.poApprovalDetail[0].remainingQuantity;
              this.popVendor = this.poApprovalDetail[0].vendorType;
              this.popPoIssueDate = (this.poApprovalDetail[0].poIssueDate);
              this.popEstDelDate = (this.poApprovalDetail[0].estimateDeliveryToWH)
              this.popPoNumber='';
              this.isCancelationApprove=this.poApprovalDetail[0].cancellationApproval;
            }

          }
          else if (action == 'GRID' || action == 'INSERT') {
            this.poGridDetail = resdata.data;
          }
          else if (action == 'UPDATE') {
            this.poGridDetail = resdata.data;
            this.displayUpdate = 0;
            this.popPoIssueQty=null;
            this.popPoNumber='';
            this.isCancelationApprove=this.poApprovalDetail[0].cancellationApproval;
          }

          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  SubmitPoApproveDetails() {
    if(this.popFAQ-this.popPoIssueQty==0)
    {
    this.GetPoApprovalDetails(0, this.popJobNumber, this.popVendor,
      this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'SUBMIT');
    }
    else if(this.popFAQ-this.popPoIssueQty>0)
    {
      this.displayPanel='block';
      this.fadeBackground='block';
      this.displayPoAssignment='none';
      this.RejectedQty=this.popFAQ-this.popPoIssueQty;
    
    }
    else{
      this.toastr.error('PO Issue Quantity can not exceed Final Approved Quantity');
    }
  }
  SubmitJobCancellation()
  {
    if(this.RemarksText!='' && this.editAction=='UPDATE')
    {
      this.GetPoApprovalDetails(this.poDetailsID, this.popJobNumber, this.popVendor,
        this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'UPDATE',this.RemarksText);
    }
    else
    {
      if(this.RemarksText!='')
      this.GetPoApprovalDetails(this.poDetailsID, this.popJobNumber, this.popVendor,
        this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'INSERT',this.RemarksText);
    }
    this.displayPanel = 'none';
    this.fadeBackground = 'none';
    this.displayPoAssignment='block';
  }
  EditPoDetails(detail: any) {
    this.popJobNumber = detail.jobNumber;
    this.popPoIssueQty = detail.poQuantity;
    this.popVendor = detail.vendorType;
    this.popPoIssueDate = detail.poIssueDate;
    this.popPoNumber = detail.poNumber;
    this.poDetailsID = detail.id;
    this.popEstDelDate = detail.estimateDeliveryToWH;
    //this.popFAQ=detail.approvedQuantity;
    this.displayUpdate = 1;
    this.poNumberUpdate= detail.poNumber;
  }
  callback() {
    this.callbackChange = 'call';
    this.GetPoApprovalDetails(0, this.popJobNumber, 0, 0, '', 0, null, null, 'SELECT');
  }

  UpdatePoDetails() {
    // this.loader='block';
    // this.ValidateJobNumber();
    // this.delay(2000).then(any => {
    //   this.loader='none';
    this.editAction='UPDATE';
    if (this.popPoIssueQty != null && this.popPoIssueQty != 0 && this.popPoNumber != '' && this.popPoNumber != undefined && this.popPoIssueDate != '') {
    //  if (this.PoNumberValidation || this.poNumberUpdate==this.popPoNumber) {
     if (this.popFAQ - this.popPoIssueQty == 0) {
      this.GetPoApprovalDetails(this.poDetailsID, this.popJobNumber, this.popVendor,
        this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'UPDATE');
      this.displayUpdate = 0;
      this.poDetailsID = 0;
      this.callback();
       }
        else if (this.popFAQ - this.popPoIssueQty > 0) {
          this.displayPanel = 'block';
          this.fadeBackground = 'block';
          this.displayPoAssignment = 'none';
          this.RejectedQty = this.popFAQ - this.popPoIssueQty;      
        }
        else{
          this.toastr.error("PO Quantity can not exceed approved quantity");
        }
 //   }
    // else {
    //   this.toastr.error("Please enter a different PoNumber,PoNumber already Exists", 'Close', 'red-snackbar');
    // }
      // this.GetPoApprovalDetails(0,this.popJobNumber,0,0,'',0,null,null,'SELECT');
    }
    else {
      this.toastr.error("Please fill the required input");
    }
//  });
  }
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay"));
}

  SavePoApproveDetails() {
    // this.loader='block';
    // this.ValidateJobNumber();
    // this.delay(2000).then(any => {
    //   this.loader='none';
    this.editAction='INSERT';
    if (this.popPoIssueQty != null && this.popPoIssueQty != 0 && this.popPoNumber != '' && this.popPoNumber != undefined && this.popPoIssueDate != '') {
      if (this.popFAQ - this.popPoIssueQty >= 0) {
       // if (this.poRemainingQuantity == this.popFAQ || this.poRemainingQuantity == this.popPoIssueQty) {
          //if (this.poGridDetail == null || (this.poGridDetail != null && !this.poGridDetail.find(m => m.vendorType == this.popVendor))) {
           // if (this.PoNumberValidation || this.poNumberUpdate==this.popPoNumber) {
              if (this.popFAQ - this.popPoIssueQty == 0) {
                this.GetPoApprovalDetails(0, this.popJobNumber, this.popVendor,
                  this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'INSERT');
                this.GetPoApprovalDetails(0, this.popJobNumber, 0, 0, '', 0, null, null, 'SELECT');
                    this.updatePO(this.gridIndex);
              }
              else if (this.popFAQ - this.popPoIssueQty > 0) {
                this.displayPanel = 'block';
                this.fadeBackground = 'block';
                this.displayPoAssignment = 'none';
                this.RemarksText='';
                this.RejectedQty = this.popFAQ - this.popPoIssueQty;
                if(this.RemarksText!='')
                {             
                this.GetPoApprovalDetails(0, this.popJobNumber, this.popVendor,
                  this.popFAQ, this.popPoNumber, this.popPoIssueQty, this.popPoIssueDate, this.popEstDelDate, 'INSERT',this.RemarksText);
                }              
              }
              else{
                this.toastr.error("PO Quantity can not exceed approved quantity");
              }
            // }
            // else {
            //   this.toastr.error("Please enter a different PoNumber,PoNumber already Exists", 'Close', 'red-snackbar');
            // }
          // }
          // else {
          //   this.toastr.error("Please select a different Vendor,Vendor already Exists", 'Close', 'red-snackbar');
          // }
      //  }
        // else {
        //   this.toastr.error("PO Quantity should be equal to Remaining Quantity " + this.poRemainingQuantity, 'Close', 'red-snackbar');
        // }
      }

      else {
        this.toastr.error("PO Quantity can not exceed approved quantity");
      }
    }
    else {
      this.toastr.error("Please fill the required input");
    }

 // });
  }



  // SavePoApprovalDetails(index: number) {
  //   if (this.poApprovedQuantity - this.poApprovalDetail[index].poQuantity >= 0) {
  //     if (this.poApprovalDetail[index].poNumber != null) {
  //       if (this.PoNumberValidation) {
  //         this.GetPoApprovalDetails(0, this.poApprovalDetail[index].jobNumber, this.poApprovalDetail[index].vendorType,
  //           this.poApprovalDetail[index].approvedQuantity, this.poApprovalDetail[index].poNumber, this.poApprovalDetail[index].poQuantity, this.poApprovalDetail[index].poIssueDate, this.poApprovalDetail[index].EstimateDeliveryToWH, 'INSERT');
  //       }
  //       else {
  //         this.toastr.error("Please enter a different PoNumber,PoNumber already Exists", 'Close', 'red-snackbar');
  //       }
  //     }
  //     else {
  //       this.toastr.error("Please fill the PO Number", 'Close', 'red-snackbar');
  //     }
  //   }
  //   else {
  //     this.toastr.error("PO Quantity can not exceed approved quantity", 'Close', 'red-snackbar');
  //   }
  // }
  UpdatePoApprovalDetails(index: number) {
    if (this.poApprovalDetail[index].approvedQuantity - this.poApprovalDetail[index].poQuantity >= 0) {
      if (this.poApprovalDetail[index].poNumber != '') {
        this.GetPoApprovalDetails(this.poApprovalDetail[index].id, this.poApprovalDetail[index].jobNumber, this.poApprovalDetail[index].vendorType,
          this.poApprovalDetail[index].approvedQuantity, this.poApprovalDetail[index].poNumber, this.poApprovalDetail[index].poQuantity, this.poApprovalDetail[index].poIssueDate, this.poApprovalDetail[index].EstimateDeliveryToWH, 'UPDATE');
          this.callback();
      }
      else {
        this.toastr.error("Please fill the PO Number");
      }
    }
    else {
      this.toastr.error("PO Quantity can not exceed approved quantity");
    }
  }

  async ValidateJobNumber() {
    if (this.popPoNumber != '' ) {
      this.loader='block';
      await  this.poStatusUpdateService.ValidatePoNumber(this.popPoNumber)
        .subscribe((resdata: any) => {
          if (resdata.status == false) {
            this.PoNumberValidation = false;
            this.loader='none';
          }
          else {
            this.PoNumberValidation = true;
            this.loader='none';
          }
        });
    }
  }
  closePopup()
  {
    this.displayPanel='none';
    this.fadeBackground='none';
    this.RemarksText="";
    this.displayPoAssignment='block';
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}